export default __webpack_public_path__ + "static/media/plataforma_persona.298fe3f6.png";